import React, { ElementType, FC } from "react";

import { Typography, TypographyProps } from "@mui/material";

import { ColorDisabled, ColorPrimary } from "./theme";

export type IgTypographyStyle =
  | "regular"
  | "thin"
  | "semibold"
  | "semiboldCaps"
  | "title"
  | "disabled"
  | "link"
  | "code";

export interface IgTypographyProps extends TypographyProps {
  disabled?: boolean;
  component?: ElementType<any> | undefined;
  igStyle?: IgTypographyStyle;
}

/**
 * @see Typography
 */
export const IgTypography: FC<IgTypographyProps> = (props) => {
  const { children, disabled, igStyle, sx, ...rest } = props;

  if (igStyle === "disabled" || disabled) {
    return (
      <Typography
        component={"span"}
        {...rest}
        sx={{ color: ColorDisabled.main, ...sx }}
      >
        {children}
      </Typography>
    );
  }

  if (igStyle === "thin") {
    return (
      <Typography component={"span"} {...rest} sx={{ fontWeight: 300, ...sx }}>
        {children}
      </Typography>
    );
  }

  if (igStyle === "semibold") {
    return (
      <Typography component={"span"} {...rest} sx={{ fontWeight: 600, ...sx }}>
        {children}
      </Typography>
    );
  }
  if (igStyle === "link") {
    return (
      <Typography
        component={"span"}
        {...rest}
        sx={{
          fontWeight: 600,
          color: ColorPrimary.main,
          "&:hover": { cursor: "pointer" },
          ...sx,
        }}
      >
        {children}
      </Typography>
    );
  }

  if (igStyle === "title") {
    return (
      <Typography
        component={"span"}
        {...rest}
        sx={{
          fontWeight: "semibold",
          textTransform: "uppercase",
          fontSize: "24px",
          ...sx,
        }}
      >
        {children}
      </Typography>
    );
  }

  if (igStyle === "semiboldCaps") {
    return (
      <Typography
        component={"span"}
        {...rest}
        sx={{ fontWeight: 600, textTransform: "uppercase", ...sx }}
      >
        {children}
      </Typography>
    );
  }

  if (igStyle === "code") {
    return (
      <Typography
        component={"span"}
        {...rest}
        sx={{ fontSize: "13px", fontFamily: "Monospace", ...sx }}
      >
        {children}
      </Typography>
    );
  }
  return (
    <Typography {...rest} component={"span"} sx={{ ...sx }}>
      {children}
    </Typography>
  );
};
